<template lang="pug">
.cp-apply-list
  .w
    .title 应用场景
    .content.fix
      .left.fl
        p.left-title
          span(v-for="v in info.titles") {{ v }}
        p.left-content {{info.content}}
        //- .logo-wrap(v-if="logoList")
        //-   .img-wrap(v-for="v in logoList")
        //-     img(:src="v.src", :style="v.style")
      img.fr(:src="img.src", :style="img.style")
</template>
<script>
export default {
  components: {},
  props: {
    info: {
      type: Object,
    },
    img: {
      type: Object,
    },
    logoList: {
      type: Array,
    }
  },
  data () {
    return {
    }
  },
  computed: {},
  methods: {
    showModal () {
      this.$emit('showModal', true)
    }
  }
}
</script>
<style lang="stylus">
.cp-apply-list
  padding-top 100px
  background url('../../../assets/kehushuo-bg.png') bottom / 100% no-repeat
  .title
    margin-bottom 33px
  .content
    margin-left 50px
    .left
      width 480px
      margin-top 78px
      margin-left 49px
      .left-title
        span
          position relative
          font-size 24px
          font-weight 800
          color rgba(98,242,255,1)
          &:nth-child(2)
            padding 0px 8px
            margin-left 8px
            &::before
              content ''
              width 1px
              height 16px
              background rgba(255,255,255,.4)
              position absolute
              top 7px
            &::before
              left 0px
            // &::after
            //   right 0px
          &:nth-child(3)
            padding 0px 8px
            &::before
              content ''
              width 1px
              height 16px
              background rgba(255,255,255,.4)
              position absolute
              top 7px
            &::before
              left 0px
            // &::after
            //   right 0px
      .left-content
        margin-top 20px
        margin-bottom 20px
        font-size 16px
        font-weight 400
      .left-btn
        display block
        width 166px
        height 50px
        line-height 45px
        text-align center
        color rgba(98,242,255,1)
        font-size 18px
        box-shadow 0px 2px 4px 0px rgba(255,255,255,0.09)
        border-radius 5px
        background rgba(98,242,255,0.2)
        border 2px solid rgba(98,242,255,1)
        cursor pointer
        transition all .3s
        &:hover
          background rgba(98,242,255,.4)
      .logo-wrap
        height 50px
        margin-top 90px
        margin-bottom 148px
        .img-wrap
          display inline-block
          vertical-align middle
          position relative
          img
            vertical-align bottom
          &:nth-child(2)
            padding 0px 18px
            margin 0px 22px
            &::before, &::after
              content ''
              width 1px
              height 16px
              background rgba(255,255,255,.4)
              position absolute
              top 50%
              transform translate(0, -50%)
            &::before
              left 0px
            &::after
              right 0px
    img
      width 488px
</style>
